var map = {
	"./0.png": "GLKx",
	"./1.png": "Eurk",
	"./2.png": "91j1",
	"./3.png": "i31R",
	"./4.png": "r8dg",
	"./5.png": "s3FL"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "k42v";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/nationalDay/gift ^\.\/.*\.png$
// module id = k42v
// module chunks = 2